import { useMemo } from 'react'

import { ModalDialog } from 'core-components/library/modalDialog'

import { QBRFinalizeModalContent } from './QBRFinalizeModalContent'

interface ISaveSettingsModalProps {
  show: boolean
  onCloseButtonClick: () => void
  onFinalizeWithoutSavingClick: () => void
  onFinalizeWithSavingClick: () => void
}

export const QBRFinalizeModal = ({
  show,
  onCloseButtonClick,
  onFinalizeWithSavingClick,
  onFinalizeWithoutSavingClick,
}: ISaveSettingsModalProps) => {
  const contentProps = useMemo(
    () => ({ onCloseButtonClick, onFinalizeWithSavingClick, onFinalizeWithoutSavingClick }),
    [onCloseButtonClick, onFinalizeWithSavingClick, onFinalizeWithoutSavingClick]
  )
  return (
    <ModalDialog
      size={'xs'}
      content={QBRFinalizeModalContent}
      contentProps={contentProps}
      show={show}
      closeOnOutsideClick={false}
      onClose={onCloseButtonClick}
    />
  )
}
